// Z-Index values for layering
export const Z_INDEX = {
  modal: 2000,
  overlay: 1500,
  drawer: 1000,
  header: 100,
  bottomNav: 50,
} as const;

// Map configuration
export const MAP_CONFIG = {
  defaultCenter: [9.9312, 76.2673] as [number, number], // Kochi, Kerala
  defaultZoom: 13,
  maxZoom: 19,
  markerIconSize: [20, 20] as [number, number],
  markerIconAnchor: [10, 10] as [number, number],
} as const;

// Brand colors
export const BRAND_COLORS = {
  primary: '#8bc43e',
  error: '#ef4444',
  warning: '#f59e0b',
  success: '#10b981',
} as const;

// Transaction simulation
export const TRANSACTION_SIMULATION = {
  successRate: 0.9, // 90% success rate
  defaultDuration: 62, // minutes
  defaultMeterStart: 32000,
} as const;

// Battery level thresholds
export const BATTERY_THRESHOLDS = {
  low: 20,
  medium: 50,
  high: 80,
  full: 100,
} as const;

// API endpoints (for future backend integration)
export const API_ENDPOINTS = {
  locations: '/api/locations',
  chargepoints: '/api/chargepoints',
  transactions: '/api/transactions',
  wallet: '/api/wallet',
  user: '/api/user',
  vehicles: '/api/vehicles',
} as const;
